import { Flex } from '@chakra-ui/react';
import { addYears, startOfDay } from 'date-fns';
import { useDispatch } from 'react-redux';
import { useSelectedView } from 'reducers/viewsSlice';
import {
  setDateRangeOneOnOneInsightsFilters,
  useOneOnOneInsightsFiltersData,
} from 'screens/oneOnOneRabbit/Insights/slice/OneOnOneInsightsFiltersSlice';

import { past3Months } from 'constants/ProjectConstants';
import { sendChangedTimelineEvent } from 'constants/mixpanelHelper';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';

import { OneOnOneGroupBy } from './OneOnOneGroupBy';

const OneOnOneMetaFilters = () => {
  const selectedCohort = useSelectedView();
  const dispatch = useDispatch();

  const { selectedIntent, dateRange } = useOneOnOneInsightsFiltersData() ?? {};

  const { showTimelineDropdown, showGroupByDropdown } = selectedIntent ?? {};

  // eslint-disable-next-line no-shadow
  const updateDateRange = (dateRange) => {
    // Sending changed timeline event
    sendChangedTimelineEvent({
      eventProperties: {
        cohort: selectedCohort?.name,
        cohortId: selectedCohort?.id,
        source: '1:1s',
        type: 'insights',
        value: dateRange?.label ?? '',
      },
    });

    // Dispatching date range update
    dispatch(setDateRangeOneOnOneInsightsFilters({ dateRange }));
    // queryClient.invalidateQueries([oneOnOneLandingPageReactQueryKeys.oneOnOneLandingPageDetails]);
  };

  // const onDataForChange = (value: string) => {
  //   history.push(value);
  // };

  return (
    <Flex gap="12px">
      {/* <Dropdown>
        <DropdownTrigger asChild>
          <DropdownChip className="chip-dropdown">
            <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
              Data for :
            </TextBodyMedium>
            <TextBodyMedium bold color="text.g1">
              {selectedL1Label}
            </TextBodyMedium>
          </DropdownChip>
        </DropdownTrigger>
        <DropdownContent>
          <DropdownRadioGroup value={l1Module}>
            {DATA_FOR_OPTIONS.filter((option) => option.visible()).map((option) => {
              const { label, value, type } = option;
              // Checking if the dataFor (value) is applicable for the selected intent
              if (applicableDataFor && !applicableDataFor[value]) {
                return null;
              }
              if (type === 'RADIO') {
                return (
                  <DropdownSub>
                    <DropdownSubTrigger>
                      <DropdownRadioItem key={value} value={value}>
                        {label}
                      </DropdownRadioItem>
                    </DropdownSubTrigger>
                    <DropdownSubContent>
                      <DropdownRadioGroup key={value} value={teamType}>
                        {option.options.map((radioOption) => (
                          <DropdownRadioItem
                            key={radioOption.value}
                            value={radioOption.value}
                            onSelect={() => onDataForChange(applicableDataFor[value][radioOption.value])}
                          >
                            {radioOption.label}
                          </DropdownRadioItem>
                        ))}
                      </DropdownRadioGroup>
                    </DropdownSubContent>
                  </DropdownSub>
                );
              }

              return (
                // @ts-expect-error fix this type
                <DropdownRadioItem key={value} value={value} onSelect={() => onDataForChange(applicableDataFor[value])}>
                  {label}
                </DropdownRadioItem>
              );
            })}
          </DropdownRadioGroup>
        </DropdownContent>
      </Dropdown> */}
      {showGroupByDropdown && <OneOnOneGroupBy />}
      {showTimelineDropdown && (
        <DateRangeDropdown
          // @ts-expect-error idk :(
          onSelect={updateDateRange}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={dateRange ?? past3Months}
          showPredefinedRanges
          variant="chip"
        />
      )}
    </Flex>
  );
};

export { OneOnOneMetaFilters };
